import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairportcabservice() {



const cardData = {
  keyword: "Mumbai Airport Cab Service",
  heading: "Lotus Cab: Mumbai Airport Cab Service",

headingDescription:
    "Lotus Cabs provides reliable and affordable Mumbai Airport Cab Service for domestic and international airport transfers, business travel, corporate transportation, hotel transfers, railway station pickups, family travel, sightseeing tours, outstation trips, and one-way or round-trip bookings. We offer a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, real-time flight tracking, transparent pricing, doorstep pickup and drop, well-maintained vehicles, and punctual service, Lotus Cabs ensures a smooth, comfortable, and hassle-free airport transfer experience to and from Chhatrapati Shivaji Maharaj International Airport (CSMIA), Mumbai.",

  top: "Popular Destinations from Mumbai Airport",

topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently booked destinations from Mumbai Airport for business travelers, corporate executives, students, families, and tourists. Whether you are arriving on a domestic or international flight, Lotus Cabs offers comfortable airport transfers via the Mumbai–Pune Expressway with professional chauffeurs, clean vehicles, and reliable door-to-door service for both one-way and round-trip travel."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular hill station located between Mumbai and Pune, famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and beautiful green valleys. Travelers landing at Mumbai Airport often book Lotus Cabs for a direct and comfortable journey to enjoy a refreshing weekend getaway amidst the scenic Western Ghats."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most important pilgrimage destinations, attracting millions of Sai Baba devotees every year. Lotus Cabs provides dependable Mumbai Airport to Shirdi taxi services with experienced chauffeurs, spacious vehicles, and flexible one-way, round-trip, or customized pilgrimage packages for a peaceful and convenient journey."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, Sula Vineyards, and the world-famous Kumbh Mela. Whether you are traveling for pilgrimage, wine tourism, business, or sightseeing, Lotus Cabs offers safe and comfortable airport cab services from Mumbai Airport directly to Nashik."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most scenic hill stations, known for Venna Lake, strawberry farms, Arthur's Seat, Wilson Point, and breathtaking mountain landscapes. Travelers arriving at Mumbai Airport can enjoy a relaxing road trip with Lotus Cabs while experiencing premium comfort throughout the journey."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most loved beach destination, famous for its pristine beaches, Portuguese heritage, vibrant nightlife, churches, forts, and luxury resorts. Lotus Cabs provides long-distance Mumbai Airport to Goa cab services with spacious vehicles, professional drivers, and flexible travel options for families, couples, and groups."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a favorite coastal getaway located close to Mumbai, known for Kolaba Fort, Alibaug Beach, Kashid Beach, beach resorts, and water sports. Visitors arriving at Mumbai Airport frequently choose Lotus Cabs for a comfortable transfer to enjoy a relaxing beach vacation on the Konkan coast."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to world-famous attractions including Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, Bibi Ka Maqbara, and Daulatabad Fort. Lotus Cabs offers reliable airport transfers from Mumbai Airport to Aurangabad, making heritage tours, pilgrimage journeys, and family vacations convenient and stress-free."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is renowned for the sacred Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian cuisine. Travelers arriving at Mumbai Airport can book Lotus Cabs for safe and comfortable long-distance transportation to Kolhapur for pilgrimage, business, or leisure travel."
    },
    {
        title: "Matheran",
        description:
            "Matheran is Asia's only automobile-free hill station and is famous for its scenic viewpoints, toy train, lush forests, waterfalls, and peaceful atmosphere. Lotus Cabs provides convenient Mumbai Airport to Matheran taxi services, making it an excellent destination for families, honeymoon couples, and weekend travelers seeking a refreshing escape from city life."
    }
],

  services: [
    {
      name: "Mumbai Airport Cab",
      description:
        "Lotus Cab provides reliable Mumbai Airport cab services for both domestic and international terminals. Our drivers monitor flight timings for accurate pickup coordination. AC sedans and SUVs ensure comfortable airport transfers. Transparent fare structure maintained. Ideal for families and business travelers. 24/7 availability ensured."
    },
    {
      name: "AC Cab Mumbai Airport",
      description:
        "Fully air-conditioned vehicles available for comfortable airport travel. Clean interiors maintained for hygiene and safety. Suitable for all seasons and long city travel. Professional chauffeur service included. Affordable pricing options available."
    },
    {
      name: "Sedan Cab Mumbai Airport",
      description:
        "Economical sedan options perfect for solo travelers and couples. Fuel-efficient and budget-friendly travel. Smooth city navigation ensured. Comfortable seating and luggage support provided."
    },
    {
      name: "SUV Cab Mumbai Airport",
      description:
        "Spacious SUV taxis ideal for families and group travel. Extra luggage space available. Comfortable AC interiors maintained. Suitable for long-distance airport transfers."
    },
    {
      name: "Luxury Cab Mumbai Airport",
      description:
        "Premium luxury vehicles available for VIP and executive transfers. Professional chauffeur-driven service included. Ideal for corporate clients and special occasions. Superior comfort guaranteed."
    },
    {
      name: "Online Cab Booking Mumbai Airport",
      description:
        "Instant online booking available with quick confirmation. Flexible scheduling options provided. Transparent pricing shared before confirmation. 24/7 customer support available."
    }
  ],

  tableData: [
    ["Mumbai Airport Cab", "AC Cab Mumbai Airport"],
    ["Sedan Cab Mumbai Airport", "SUV Cab Mumbai Airport"],
    ["Luxury Cab Mumbai Airport", "Online Cab Booking Mumbai Airport"],
    ["Airport Pickup Cab Mumbai", "Airport Drop Cab Mumbai"],
    ["Family Trip Cab Mumbai Airport", "Corporate Cab Mumbai Airport"],
    ["One Way Cab Mumbai Airport", "Round Trip Cab Mumbai Airport"],
    ["Weekend Trip Cab Mumbai Airport", "Mini Bus Cab Mumbai Airport"],
    ["Chauffeur Driven Cab Mumbai Airport", "Budget Cab Mumbai Airport"],
    ["Same Day Return Cab Mumbai Airport", "Outstation Taxi Mumbai Airport"],
    ["Per Km Rate Cab Mumbai Airport", "Best Cab Service Mumbai Airport"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Flight Tracking Support",
      WhyChoosedescription:
        "We monitor flight arrival and departure timings to ensure punctual pickup without waiting stress."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock airport transfer service including early morning and late-night pickups."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Upfront fare structure shared before booking confirmation. No hidden charges."
    },
    {
      WhyChooseheading: "Wide Vehicle Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury cars, and mini buses available."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Experienced and background-verified drivers ensure safe city navigation."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Regular vehicle maintenance and hygiene checks performed."
    },
    {
      WhyChooseheading: "Corporate & Family Friendly",
      WhyChoosedescription:
        "Packages available for business travelers and family airport transfers."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated team available for assistance during booking and travel."
    }
  ]
};

const faqData = [
  {
    question: "Do you monitor flight delays?",
    answer:
      "Yes, we track flight timings to adjust pickup schedules and avoid waiting issues."
  },
  {
    question: "Is 24/7 airport service available?",
    answer:
      "Yes, we provide round-the-clock airport pickup and drop service."
  },
  {
    question: "Are luxury vehicles available?",
    answer:
      "Yes, premium luxury car options are available for executive transfers."
  },
  {
    question: "Is online booking available?",
    answer:
      "Yes, instant online booking confirmation provided with customer support."
  },
  {
    question: "Is pricing fixed or per km?",
    answer:
      "We offer both fixed airport packages and per-kilometer pricing options."
  },
  {
    question: "Is SUV recommended for family travel?",
    answer:
      "SUV is ideal for families due to extra comfort and luggage space."
  },
  {
    question: "Do you provide outstation transfers from airport?",
    answer:
      "Yes, outstation taxi services available directly from Mumbai Airport."
  },
  {
    question: "Is chauffeur service included?",
    answer:
      "Yes, all airport transfers include professional chauffeur service."
  },
  {
    question: "Is same-day return available?",
    answer:
      "Yes, same-day return packages available depending on route."
  },
  {
    question: "Do you support corporate billing?",
    answer:
      "Yes, invoice billing support available for corporate clients."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "Airport pickup was punctual even though my flight was delayed. Driver was professional and vehicle was clean.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Client",
    feedback:
      "Used service for business guests. Smooth coordination and reliable airport transfer.",
    rating: 5
  },
  {
    id: 3,
    name: "Mrs. Anjali Mehta",
    feedback:
      "SUV was spacious and comfortable for family airport drop. Highly recommended service.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Nilesh Patil",
    feedback:
      "Transparent pricing and smooth city travel. Excellent airport cab experience.",
    rating: 5
  }
];

































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai Airport Cab Service",
"image": "https://lotuscab.com/assets/images/mumbai-airport-cab-service.jpg",
"description": "Book Mumbai Airport Cab Service with Lotus Cab for safe, reliable, and comfortable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "8420"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-airport-cab-service"
}
};







  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport Cab Service | 24x7 Airport Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai Airport Cab Service with Lotus Cab for reliable airport transfers. 24x7 pickup and drop service with Sedan, SUV, and AC cabs at affordable fares. Professional drivers and instant booking confirmation."
/>

<meta
 name="keywords"
 content="Mumbai Airport Cab Service, Mumbai Airport Taxi, Airport Cab Mumbai, Mumbai Airport Pickup Cab, Mumbai Airport Drop Cab, CSMIA Cab Service, Airport Taxi Mumbai, Cheap Mumbai Airport Cab, Best Mumbai Airport Taxi, Online Airport Cab Booking Mumbai, Sedan Airport Cab Mumbai, SUV Airport Cab Mumbai, 24x7 Airport Cab Mumbai, Lotus Cab Mumbai Airport"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairportcabservice;